const I18N = {
  en: {
    nameError: 'gcds-icon: Invalid name.',
  },
  fr: {
    nameError: 'gcds-icon: Nom invalide.',
  },
};

export default I18N;
